export const buy = {
  en: {
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    soldOut: "Sold Out",
    outOfStock: "Out of Stock",
    makeSelection: "Make your selection",
    // CTA %%ACTION%% fills (LandingPageCtaButton / ButtonBuy / promo blocks).
    selectSizeNow: "Select Size Now",
    shopNow: "Shop Now",
    // ShopMenWomen homepage block gender-split CTAs.
    shopMen: "Shop Men",
    shopWomen: "Shop Women",
    // %%DATE%% server-render fallback before the client formats a real date.
    today: "Today",
  },
  de: {
    addToCart: "In den Warenkorb",
    buyNow: "Jetzt kaufen",
    soldOut: "Ausverkauft",
    outOfStock: "Nicht auf Lager",
    makeSelection: "Triff deine Auswahl",
    selectSizeNow: "Größe wählen",
    shopNow: "Jetzt shoppen",
    shopMen: "Herren shoppen",
    shopWomen: "Damen shoppen",
    today: "Heute",
  },
} as const
